import React from 'react';
import { Trophy } from 'lucide-react';
export function ProductHero() {
  return <section className="bg-[#1B4D2E] text-white py-20 px-4 text-center" data-id="element-243">
      <div className="max-w-5xl mx-auto" data-id="element-244">
        <div className="inline-flex items-center gap-2 bg-[#FFD700] text-[#1B4D2E] px-6 py-2 rounded-full font-bold text-sm md:text-base mb-8 uppercase tracking-wide" data-id="element-245">
          <Trophy size={18} data-id="element-246" />
          El Sistema N°1 para Entrenadores de Rugby Argentinos
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-[#FFD700] mb-6 leading-tight" data-id="element-247">
          RUGBY 360 — Colección Completa
          <br data-id="element-248" />
          <span className="text-white" data-id="element-249">14 Tomos + 6 Bonos + 2 Élite</span>
          <br data-id="element-250" />
          Todo resuelto, todas las categorías.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 my-16 border-y border-white/20 py-10" data-id="element-251">
          <div data-id="element-252">
            <div className="text-4xl font-bold text-white mb-2" data-id="element-253">
              +310 páginas
            </div>
            <div className="text-lg text-gray-300" data-id="element-254">de contenido listo</div>
          </div>
          <div data-id="element-255">
            <div className="text-4xl font-bold text-white mb-2" data-id="element-256">
              +120 sesiones
            </div>
            <div className="text-lg text-gray-300" data-id="element-257">listas para usar mañana</div>
          </div>
          <div data-id="element-258">
            <div className="text-4xl font-bold text-white mb-2" data-id="element-259">
              Todas las categorías
            </div>
            <div className="text-lg text-gray-300" data-id="element-260">M6 a M23</div>
          </div>
        </div>

        <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-261">
          Los 14 Tomos Completos
          <br data-id="element-262" />
          <span className="text-[#FFD700] text-xl md:text-2xl mt-2 block font-normal" data-id="element-263">
            Sesiones listas · Por categoría y bloque · Listo para usar mañana
          </span>
        </h3>
      </div>
    </section>;
}